import React, { type FC, useMemo } from 'react';
import { isEmpty } from 'lodash-es';
import clsx from 'clsx';
import { FlexBox, Text } from '@is24at/react-ui-core';
import { Image } from '@is24at/react-image';
import { getAwardsByActiveFeatures, type Award } from './Awards';
import styles from './Awards.scss';

type AwardImageProps = {
  award: Award;
};

export const AwardImage: FC<AwardImageProps> = ({ award }) => (
  <div className={clsx(styles[`award-image__${award.className}`])}>
    <Image
      pictureCn={styles['award-image']}
      alt={award.imageAlt}
      src={award.imageUrl}
    />
  </div>
);

type AwardImagesProps = {
  companyName: string;
  activeFeatures: string[];
};

export const AwardImages: FC<AwardImagesProps> = ({
  companyName,
  activeFeatures,
}) => {
  const awards = useMemo(
    () => getAwardsByActiveFeatures(activeFeatures),
    [activeFeatures],
  );

  if (isEmpty(awards)) {
    return null;
  }

  return (
    <FlexBox
      className={styles['award-images__container']}
      direction="column"
      alignItems="flex-start"
      spacing={32}
    >
      <Text size="l" bold>
        Auszeichnungen von {companyName}
      </Text>
      <FlexBox
        className={styles['award-images']}
        justifyContent="center"
        alignItems="center"
        spacing={24}
      >
        {awards.map((award) => (
          <AwardImage key={award.feature} award={award} />
        ))}
      </FlexBox>
    </FlexBox>
  );
};
